
  document.addEventListener('DOMContentLoaded', function () {
    async function getCartTotal() {
      const res = await fetch('/cart.js');
      const data = await res.json();
      return data.total_price / 100;
    }

    function updateShippingBar(totalCart, valueTax) {
      const bar = document.getElementById('shipping-bar');
      const fill = document.getElementById('shipping-fill');
      const text = document.getElementById('shipping-text');
      const container = document.getElementById('barracart');

      if (!bar || !fill || !text || !container) return;

      if (valueTax === null) {
        text.innerText = `Frete grátis indisponível para a sua região`;
        fill.style.width = `0%`;
        container.style.display = 'block';
        return;
      }

      const progress = Math.min((totalCart / valueTax) * 100, 100).toFixed(2);
      const valorRestante = (valueTax - totalCart).toFixed(2);

      fill.style.width = `${progress}%`;

      if (totalCart >= valueTax) {
        text.innerText = "Parabéns, você ganhou frete grátis!";
      } else {
        text.innerText = `Falta R$ ${valorRestante.replace('.', ',')} para obter frete grátis`;
      }

      // Exibir a barra
      if (totalCart > 0) container.style.display = 'block';
    }

    function getFreteValue() {
      return new Promise((resolve) => {
        const saved = localStorage.getItem('valueTax');
        if (saved) return resolve(parseFloat(saved));

        fetch('https://ipinfo.io?token=140a676aebc5e1')
          .then(res => res.json())
          .then(data => {
            const region = data.region;
            let valueTax = null;

            if (["Paraná", "Rio Grande do Sul", "Santa Catarina"].includes(region)) {
              valueTax = 450;
            } else if (["São Paulo", "Rio de Janeiro", "Espírito Santo", "Minas Gerais"].includes(region)) {
              valueTax = 550;
            } else if (["Goiás", "Mato Grosso", "Mato Grosso do Sul", "Distrito Federal"].includes(region)) {
              valueTax = 1300;
            } else if (["Bahia", "Pernambuco", "Ceará", "Maranhão", "Paraíba", "Sergipe", "Alagoas", "Rio Grande do Norte", "Piauí"].includes(region)) {
              valueTax = 1300;
            } else {
              valueTax = null;
            }

            localStorage.setItem('valueTax', valueTax);
            resolve(valueTax);
          })
          .catch(() => resolve(299)); // fallback
      });
    }

    async function initShippingBar() {
      const [valueTax, totalCart] = await Promise.all([getFreteValue(), getCartTotal()]);
      updateShippingBar(totalCart, valueTax);
    }

    // Executa ao carregar
    initShippingBar();

    // Reexecuta após adicionar produto ao carrinho (Shopify padrão)
    document.body.addEventListener('ajaxCart:afterAdd', initShippingBar);

    // Ou observe o DOM se não usa ajaxCart
    document.body.addEventListener('click', function (e) {
      if (e.target.closest('form[action="/cart/add"]') || e.target.closest('[data-product-atc]')) {
        setTimeout(initShippingBar, 1000); // tempo para o carrinho atualizar
      }
    });
  });

